var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotifyBellIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.548,
    height: 23.639,
    viewBox: "0 0 19.548 23.639",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_20160",
    "data-name": "Path 20160",
    d: "M150.732,36.657,149.2,32.5a3.89,3.89,0,0,1-.242-1.352V26.734a8.071,8.071,0,0,0-6.623-7.94v-.111a1.182,1.182,0,1,0-2.364,0v.083a7.869,7.869,0,0,0-6.774,7.8v4.579a3.9,3.9,0,0,1-.242,1.352l-1.535,4.161a1.869,1.869,0,0,0,1.752,2.517h5.339a2.758,2.758,0,0,0,5.285,0h5.188a1.869,1.869,0,0,0,1.753-2.517Zm-1.513.815h0a.287.287,0,0,1-.24.125H133.168a.293.293,0,0,1-.276-.394l1.537-4.161a5.47,5.47,0,0,0,.339-1.9v-4.58a6.3,6.3,0,0,1,6.3-6.3c.079,0,.155,0,.233,0a6.446,6.446,0,0,1,6.074,6.471v4.409h0a5.464,5.464,0,0,0,.339,1.9l1.535,4.162a.288.288,0,0,1-.034.269Z",
    transform: "translate(-131.3 -17.501)",
    fill: "#3f81f4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifyBellIcon);
export default __webpack_public_path__ + "static/media/notify-bell-icon.ce6086851bc85cd266dfabdaf860e4e5.svg";
export { ForwardRef as ReactComponent };